module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOpJREFUeNpiZMACTp06dR5IGQDxBTMzM0MgPwHIng+VDgSKbUDXw4TFEAWoIQxIdDySknpsljMBNTYA8X8obgDa9gCLug9IbAOoZRguqidkGxBsROPnE/QaEjgAYwBduQDNVQGkGHQQjY8cwApA7zkQZRDQFQ1oQgvR+PEYBgE1MYIwHteB1IC8+gCX9/B5DRtA9p4ANH2RZdBENL4/WQZB09gFZO8BXSVAjouwBXoCuQYtwBZ7TND8Bc4iRHrvA1qgg7MMThcRMBgjy5DjNaxZhiyDsGUZkEGNSAIw9gU0GhtoRHLVAoAAAwCmF1KZH9OnBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/kuozhan.png
// module id = 2ubd
// module chunks = 1